import { pushGlobalLoading, popGlobalLoading } from "./progress";

const shouldSkip = (config) =>
  config?.skipGlobalLoader === true ||
  config?.headers?.["X-Skip-Global-Loader"] === "1";

/**
 * Attach global loading counter + NProgress to an axios instance.
 */
export function installApiLoadingInterceptors(axiosInstance) {
  axiosInstance.interceptors.request.use(
    (config) => {
      if (!shouldSkip(config)) {
        pushGlobalLoading();
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      if (!shouldSkip(response.config)) {
        popGlobalLoading();
      }
      return response;
    },
    (error) => {
      const cfg = error.config;
      if (!shouldSkip(cfg)) {
        popGlobalLoading();
      }
      return Promise.reject(error);
    },
  );
}
